import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import {
  WorkspaceType,
  isOrganisationWorkspace,
} from '@principle-theorem/principle-core/interfaces';
import { type IWorkspaceSelector } from '@principle-theorem/ng-auth';
import { snapshot, type IUserWorkspace } from '@principle-theorem/shared';
import { ReplaySubject } from 'rxjs';
import { first, sortBy } from 'lodash';
import {
  InputSearchFilter,
  TypedFormControl,
  toSearchInput$,
} from '@principle-theorem/ng-shared';
import { map } from 'rxjs/operators';

@Component({
  selector: 'pr-organisation-workspace-selector',
  templateUrl: './organisation-workspace-selector.component.html',
  styleUrls: ['./organisation-workspace-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class OrganisationWorkspaceSelectorComponent
  implements IWorkspaceSelector
{
  searchCtrl = new TypedFormControl<string>('');
  workspaceSearch: InputSearchFilter<
    IUserWorkspace<WorkspaceType.Organisation>
  >;
  workspaces$: ReplaySubject<IUserWorkspace<WorkspaceType.Organisation>[]> =
    new ReplaySubject(1);

  @Output()
  workspaceSelected = new EventEmitter<IUserWorkspace>();

  @Input()
  set workspaces(workspaces: IUserWorkspace[]) {
    if (workspaces) {
      this.workspaces$.next(
        sortBy(workspaces.filter(isOrganisationWorkspace), (workspace) =>
          (workspace.name || workspace.workspace).toLowerCase()
        )
      );
    }
  }

  constructor() {
    this.workspaceSearch = new InputSearchFilter<
      IUserWorkspace<WorkspaceType.Organisation>
    >(this.workspaces$, toSearchInput$(this.searchCtrl), ['workspace', 'name']);
  }

  async selectFirstOption(): Promise<void> {
    const firstOption = await snapshot(
      this.workspaceSearch.results$.pipe(map((workspaces) => first(workspaces)))
    );
    if (firstOption) {
      this.workspaceSelected.emit(firstOption);
    }
  }
}
